import { Request } from "../utils/request";
import { IUserInfo } from "../../interfaces/IUserInfo";

export const AdminAPI = {
    updateUserInfo: (userId: number | string, userInfoDto: IUserInfo) => {
        return Request.put(`admin/${userId}/user-info`, userInfoDto)
    }
}
